import { Fragment, h } from '@stencil/core';

export enum TabGroup {
  BookingOptions = 'bookingOptions',
  Communications = 'communications',
  BookingForm = 'bookingForm',
  PageStyles = 'pageStyles',
  CalendarView = 'calendarView',
}

export type TabGroupContentsProps = {
  id: string;
  formState: any;
  activeTab: TabGroup;
  calendars?: any[];
  currentUser?: any;
  i18next: any;
};

export default function TabContentsGroup({ id, formState, activeTab }: TabGroupContentsProps, children: any) {
  return (
    <Fragment>
      {activeTab === TabGroup.CalendarView && (
        <div key={`calendar-view-${id}`} class={{ 'hide': activeTab !== TabGroup.CalendarView, 'calendar-view': true }}>
          <nylas-event-calendar />
        </div>
      )}
      <div key={`booking-options-${id}`} class={{ hide: activeTab !== TabGroup.BookingOptions }}>
        <nylas-scheduling-method
          name="availability-method"
          readOnly={true}
          exportparts="nsm, nsm__header, nsm__input-label, nsm__dropdown, nsm__dropdown-button, nsm__dropdown-content"
        />
        <nylas-custom-booking-flow exportparts={'ncbflow, ncbflow__header, ncbflow__title, ncbflow__content'}>
          <div slot="inputs">
            <nylas-booking-confirmation-type name="confirmation-type" exportparts={'nbct, nbct__header, nbct__dropdown, nbct__dropdown-button, nbct__dropdown-content'} />
            <nylas-booking-confirmation-redirect
              name="confirmation-redirect"
              exportparts={'nbcr, nbcr__header, nbcr__dropdown, nbcr__dropdown-button, nbcr__dropdown-content, nbcr__input-textfield'}
            />
          </div>
        </nylas-custom-booking-flow>
        <nylas-event-limits>
          <div slot="inputs">
            <nylas-min-booking-notice
              name="min-booking-notice"
              exportparts="nmbn, nmbn__number-dropdown, nmbn__number-dropdown-button, nmbn__number-dropdown-content, nmbn__period-dropdown, nmbn__period-dropdown-button, nmbn__period-dropdown-content"
            />
            <nylas-min-cancellation-notice
              name="min-cancellation-notice"
              exportparts="nmcn, nmcn__number-dropdown, nmcn__number-dropdown-button, nmcn__number-dropdown-content, nmcn__period-dropdown, nmcn__period-dropdown-button, nmcn__period-dropdown-content"
            />
            <nylas-cancellation-policy name="cancellation-policy" exportparts="ncpolicy, ncpolicy__textarea" />
          </div>
        </nylas-event-limits>
        <nylas-customize-booking-settings
          showSettings={['hideCancellationOptions', 'hideReschedulingOptions']}
          name="customize-booking-settings"
          exportparts="ncbs, ncbs__header, ncbs__settings, ncbs__settings-div, ncbs__additional_guests, ncbs__cancellation_options, ncbs__rescheduling_options"
        />
      </div>
      <div key={`communications-${id}`} class={{ hide: activeTab !== TabGroup.Communications }}>
        <nylas-disable-emails name="disable-emails" exportparts="nde, nde__toggle-label, nde_toggle-input, nde_toggle-slider" />
        {!formState?.disableEmails && (
          <Fragment>
            <nylas-confirmation-email
              name="confirmation-email-template"
              exportparts={
                'nce, nce__tab-heading, nce__header, nce__body, nce__confirmation-email-toggle--container, nce__summary, nce__reminder-input_dropdown, nce__reminder-input_dropdown-input, nce__reminder-input_dropdown-content'
              }
            />
            <nylas-reminder-emails
              name="reminder-overrides"
              exportparts={
                'nre, nre__tab-heading, nre__header, nre__body, nre__confirmation-email-toggle--container, nre__summary, nrt, nrt__number-dropdown, nrt__number-dropdown-button, nrt__number-dropdown-content, nrt__period-dropdown, nrt__period-dropdown-button, nrt__period-dropdown-content, nrt__time-period-selector'
              }
            />
          </Fragment>
        )}
      </div>
      <div key={`page-styles-${id}`} class={{ hide: activeTab !== TabGroup.PageStyles }}>
        <nylas-custom-event-slug name="custom-event-slug" exportparts="nces, nces__body, nces__header, nces__drawer-toggle--container, nces__input-textfield" />
        <nylas-page-name name="page-name" requirePageName={true} exportparts="npn, npn__body, npn__header, npn__drawer-toggle--container, npn__input-textfield" />
        <nylas-page-styling
          name="page-styling"
          exportparts="nps, nps__header, nps__drawer-toggle--container, nps__body, nps__title-input-textfield, nps__company-logo-input-textfield, nps__color-picker, nps__color-picker-button, nps__color-picker-button-label, nps__color-picker-selected-label, nps__submit-button-label-input-textfield, nps__message-textarea"
        >
          {children}
        </nylas-page-styling>
      </div>
      <div key={`booking-form-${id}`} class={{ hide: activeTab !== TabGroup.BookingForm }}>
        <nylas-booking-form-config
          name="additional-fields"
          exportparts="nbfc, nbfc__header, nbfc__add_field, nbfc__add_field-button, nbfc__add_field-content, nbfc__static_fields, nbfc__additional_fields, nbfc__form-field, nbfc__form-field-header, nbfc__form-field-content"
        />
      </div>
    </Fragment>
  );
}
